/**
 * Created by arnoldelite on 2017-02-15.
 */

var Model = require("../types/Model.js");
var xtend = require("xtend");
//var xtend = require("xtend");

/**
 * This model is used for tracking a person's reminder history(irrespective of the status of the reminder).
 * A notification contains all of the messages, calls and banners that a person has received
 * @type {Model}
 */

module.exports = Model({
	name: "managedreminderhistory",
	init: init,
	uninit: uninit,

	listeners: listeners,
	triggers: triggers,
	_who: "",
	_page: null,
	_history: null,
	_reminders: null,
	_localization: null,
	_who_tracker: null,

	refresh: refresh,
	recalculate: recalculate
});

function listeners() {
	return {
		"managedreminders:updated": handle_reminders_updated,
		"connectivity:online": refresh,
		"managedreminders:view": recalculate,
		"managedpendingreminders:updated": refresh,
		"localization:updated": handle_localization_updated
	};
}

function triggers() {
	return {
		more: more,
		view: view
	};
}

function init() {
	this._page = 0;
	this._who = null;
	this._history = [];
	this._reminders = [];
	this._localization = {};
	this._who_tracker = this.dispatcher.createTracker();
	this.push([]);
	this.refresh();
}

function uninit() {
	this._who_tracker.off();
	this._who_tracker = null;
	this._history = null;
	this._reminders = null;
	this._localization = null;
	this._page = null;
	this._who = null;
}

function view(data) {
	var who = data.who;
	var group = data.group;
	if (who === this._who) return;
	this._who = who;
	this._group = group;

	this._who_tracker.off();
	if(group)
		if (Array.isArray(group))
			group.forEach(g => {
				this._who_tracker.on("mqtt:managegroup/" + g + "/patient/u/" + who + "/reminders/removed", refresh.bind(this));
			});
		else
			this._who_tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/reminders/removed", refresh.bind(this));
	else
		this._who_tracker.on("mqtt:u/" + who + "/reminders/removed", refresh.bind(this));

	this.refresh();
}

function refresh() {
	var who = this._who;
	if (!who) return;
	const group = this._group;
	this._page = 0;
	this.emit("save:trigger:start");
	return this.api.manage.reminders.history.listall(this._page, who, group)
		.then(handle_load.bind(this))
		.catch(console.error.bind(console))
		.then(finishLoad.bind(this));
}

function handle_load(list) {
	this._history = list;
	this.recalculate();
}

function finishLoad() {
	this.emit("save:trigger:finish");
}

function more() {
	this.emit("save:trigger:start");
	this.emit("usermetrics:trigger:track", "load more of managed user's reminder history", {
		who: this._who,
		page: this._page
	});
	this._page++;
	return this.api.manage.reminders.history.listall(this._page, this._who, this._group)
		.then(handle_more.bind(this))
		.catch(console.error.bind(console))
		.then(finishLoad.bind(this));
}

function handle_more(list) {
	this._history = this._history.concat(list);
	this.recalculate();
}

function handle_reminders_updated(data) {
	this._reminders = data.list;
	this.recalculate();
}

function handle_localization_updated(data) {
	this._localization = data;
}

function recalculate() {
	var reminders = this._reminders;
	var history = this._history;
	var localization = this._localization;

	this.push(history.map(function (item) {
		var reminder = findReminder(reminders, item) || {
			content: "N/A"
		};

		var reminderContent = reminder.content;
		var reminderReadable = timestamp(item.updated_at, checkLanguage(localization.language));

		var response = item.response || item.response === 0 ? item.response : "N/A";

		if (item.history.accepted) response = "Accepted";

		if (item.history.denied) response = "Denied";

		if (item.history.cleared) response = "Cleared";

		return xtend(item, {
			content: reminderContent,
			readable: reminderReadable,
			response: response
		});
	})
	);
}

function findReminder(reminders, item) {
	return reminders.reduce(function (result, rem) {
		if (result) return result;
		if (rem._id === item.reminder) return rem;
		return null;
	}, null);
}

// Converts a date timestamp into a human readable timestamp
function timestamp(value, lang) {
	if (!value) return ""; // Ignore empty values
	var d = new Date(value);
	return (padNumber(d.getHours()) + ":" + padNumber(d.getMinutes()) + " - " + d.toLocaleDateString(lang, getDateOptions()));
}

// Pads numbers less than 10 with a 0
function padNumber(number) {
	if (number < 10) return "0" + number;
	return number;
}

function checkLanguage(lang) {
	if (lang === "cn_s") return "zh-CN";
	else if (lang === "cn_t") return "zh-HK";
	else return lang;
}

function getDateOptions() {
	return {
		weekday: "short",
		month: "short",
		day: "2-digit"
	};
}
